// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1mZ-k","paramInput":"JobSimulator_paramInput__2ldm_","input":"JobSimulator_input__2rBWk"};